import {useMemo} from 'react'
import {warningColors} from './constants'

export const formatDemographicOptions = subDemographics => {
  if (!subDemographics) return []

  return Object.values(subDemographics).map(demographicOption => ({
    value: demographicOption,
    label: demographicOption.displayName,
    precode: demographicOption.precode,
  }))
}

export const getSelectedOptions = (groupTempStateDemographics, demographicKey) => {
  const foundDemographic = groupTempStateDemographics.find(({key}) => key === demographicKey)

  if (foundDemographic) {
    return foundDemographic.subDemographics.map(subDemographic => ({
      value: subDemographic,
      label: subDemographic.displayName,
    }))
  }

  return []
}

export const createSelectStyles = (selectedOptionsLength, isAtLimit) => ({
  control: (baseStyles, state) => {
    return {
      ...baseStyles,
      position: 'relative',
      padding: `14px 4px ${selectedOptionsLength ? '4px' : '14px'} 4px !important`,
      color: '#989898',
      boxShadow: 'none',
      borderColor: isAtLimit ? warningColors.atLimit : '#c0c0c0',
      '&:hover': {
        boxShadow: 'none',
        borderColor: isAtLimit ? warningColors.atLimit : '#87888A',
      },
      ...(state.menuIsOpen && {
        boxShadow: 'none',
        borderColor: isAtLimit ? warningColors.atLimit : '#87888A',
        borderBottomColor: 'transparent',
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        '&:hover, &:focus-within, &:focus, &:active': {
          boxShadow: 'none',
          borderColor: isAtLimit ? warningColors.atLimit : '#87888A',
          borderBottomColor: 'transparent',
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          width: '90%',
          height: '1px',
          backgroundColor: '#E6E8EC',
          zIndex: 2,
        },
      }),
    }
  },
  menu: baseStyles => ({
    ...baseStyles,
    border: '1px solid #87888A',
    borderRadius: 0,
    boxShadow: 'none',
    borderTopColor: 'transparent',
    borderBottomRightRadius: '4px',
    borderBottomLeftRadius: '4px',
    marginTop: '-2px',
    overflow: 'hidden',
    '& > div': {
      paddingBottom: 0,
    },
  }),
  input: baseStyles => ({
    ...baseStyles,
    marginTop: selectedOptionsLength ? '-5px' : 'initial',
    '& > div': {
      margin: 0,
      padding: 0,
    },
    '& input': {
      fontSize: '16px !important',
      fontFamily: 'Roboto !important',
      color: '#5C5E63 !important',
    },
  }),
  menuList: baseStyles => ({
    ...baseStyles,
    maxHeight: '200px',
  }),
})

export const useSelectionLimits = (selectedOptionsLength, maxLimit) => {
  return useMemo(
    () => ({
      isNearLimit: selectedOptionsLength >= maxLimit - 5,
      isAtLimit: selectedOptionsLength >= maxLimit,
    }),
    [selectedOptionsLength, maxLimit],
  )
}
